module.exports = __webpack_public_path__ + "img/carousel-clientes-9.eca0f87f.png";